import { CALL_API } from 'redux-api-middleware'
import { constructEndpoint, constructQueries, containsRole } from '../utils/helpers'
import { GROUP_FILTERED_PARTNERS_REQUEST } from './group'
import { INITIAL_DATA_FAILURE } from './loading'

export const DELETE_USER_DIALOG_REQUEST = 'user/DELETE_USER_DIALOG_REQUEST'
export const DELETE_USER_DIALOG_RECEIVE = 'user/DELETE_USER_DIALOG_RECEIVE'
export const DELETE_USER_DIALOG_FAILURE = 'user/DELETE_USER_DIALOG_FAILURE'
export const DELETE_USER_FROM_GROUP_DIALOG_REQUEST = 'user/DELETE_USER_FROM_GROUP_DIALOG_REQUEST'
export const DELETE_USER_FROM_GROUP_DIALOG_RECEIVE = 'user/DELETE_USER_FROM_GROUP_DIALOG_RECEIVE'
export const DELETE_USER_FROM_GROUP_DIALOG_FAILURE = 'user/DELETE_USER_FROM_GROUP_DIALOG_FAILURE'
export const MANUAL_SET_USER_PROFILE = 'user/MANUAL_SET_USER_PROFILE'
export const PARTNER_REQUEST = 'user/PARTNER_REQUEST'
export const PARTNER_RECEIVE = 'user/PARTNER_RECEIVE'
export const PARTNER_FAILURE = 'user/PARTNER_FAILURE'
export const REMOVE_USER_ROLE_DIALOG_REQUEST = 'user/REMOVE_USER_ROLE_DIALOG_REQUEST'
export const REMOVE_USER_ROLE_DIALOG_RECEIVE = 'user/REMOVE_USER_ROLE_DIALOG_RECEIVE'
export const REMOVE_USER_ROLE_DIALOG_FAILURE = 'user/REMOVE_USER_ROLE_DIALOG_FAILURE'
export const TAB_STATE_CHANGE = 'user/TAB_STATE_CHANGE'
export const USER_GROUPS_REQUEST = 'user/USER_GROUPS_REQUEST'
export const USER_GROUPS_RECEIVE = 'user/USER_GROUPS_RECEIVE'
export const USER_GROUPS_FAILURE = 'user/USER_GROUPS_FAILURE'
export const USER_PROFILE_REQUEST = 'user/USER_PROFILE_REQUEST'
export const USER_PROFILE_RECEIVE = 'user/USER_PROFILE_RECEIVE'
export const USER_PROFILE_FAILURE = 'user/USER_PROFILE_FAILURE'
export const USER_POST_DIALOG_REQUEST = 'user/USER_POST_DIALOG_REQUEST'
export const USER_POST_DIALOG_RECEIVE = 'user/USER_POST_DIALOG_RECEIVE'
export const USER_POST_DIALOG_FAILURE = 'user/USER_POST_DIALOG_FAILURE'
export const USERS_REQUEST = 'user/USERS_REQUEST'
export const USERS_RECEIVE = 'user/USERS_RECEIVE'
export const USERS_FAILURE = 'user/USERS_FAILURE'
export const USER_GROUP_PATCH_DIALOG_REQUEST = 'user/USER_GROUP_PATCH_DIALOG_REQUEST'
export const USER_GROUP_PATCH_DIALOG_RECEIVE = 'user/USER_GROUP_PATCH_DIALOG_RECEIVE'
export const USER_GROUP_PATCH_DIALOG_FAILURE = 'user/USER_GROUP_PATCH_DIALOG_FAILURE'
export const RESET_PASSWORD_DIALOG_REQUEST = 'user/RESET_PASSWORD_DIALOG_REQUEST'
export const RESET_PASSWORD_DIALOG_RECEIVE = 'user/RESET_PASSWORD_DIALOG_RECEIVE'
export const RESET_PASSWORD_DIALOG_FAILURE = 'user/RESET_PASSWORD_DIALOG_FAILURE'
export const RESEND_VERIFICATION_EMAIL_DIALOG_REQUEST = 'user/RESEND_VERIFICATION_EMAIL_DIALOG_REQUEST'
export const RESEND_VERIFICATION_EMAIL_DIALOG_RECEIVE = 'user/RESEND_VERIFICATION_EMAIL_DIALOG_RECEIVE'
export const RESEND_VERIFICATION_EMAIL_DIALOG_FAILURE = 'user/RESEND_VERIFICATION_EMAIL_DIALOG_FAILURE'
export const SINGLE_USER_REQUEST = 'user/SINGLE_USER_REQUEST'
export const SINGLE_USER_RECEIVE = 'user/SINGLE_USER_RECEIVE'
export const SINGLE_USER_FAILURE = 'user/SINGLE_USER_FAILURE'
export const SET_FILTER = 'user/SET_FILTER'
export const SET_USER_PATCH = 'user/SET_USER_PATCH'
export const SHOW_ADMINS_DIALOG = 'showAdmins/SHOW_ADMINS_DIALOG'
export const FILTER_ADMINS = 'showAdmins/FILTER_ADMINS'

const initialState = {
  filter: [],
  needPartnerFilteredGroups: false,
  selected: [],
  userProfile: {},
  users: [],
  tabState: 0,
  totalCount: 0,
  openAdminsDialog: false,
  admins: []
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_USER_DIALOG_RECEIVE:
      const filteredUsers = state.users.filter(user => {
        return user.id !== action.meta.userId
      })
      return {
        ...state,
        users: filteredUsers
      }
    case DELETE_USER_FROM_GROUP_DIALOG_RECEIVE:
      const filteredUserGroups = state.userProfile.groups.filter(group => {
        return group.id !== action.meta.groupIdToFilter
      })
      return {
        ...state,
        userProfile: {
          ...state.userProfile,
          groups: filteredUserGroups
        }
      }
    case GROUP_FILTERED_PARTNERS_REQUEST:
      return {
        ...state,
        needPartnerFilteredGroups: false
      }
    case MANUAL_SET_USER_PROFILE:
      return {
        ...state,
        userProfile: action.payload
      }
    case PARTNER_RECEIVE:
      let returnState = { ...state }
      if (action.meta.fetchGroups) returnState.needPartnerFilteredGroups = true
      return returnState
    case REMOVE_USER_ROLE_DIALOG_RECEIVE:
      const filteredUserRoles = state.userProfile.roles.filter(role => {
        return role.id !== action.meta.roleId
      })
      return {
        ...state,
        userProfile: {
          ...state.userProfile,
          roles: filteredUserRoles
        }
      }
    case SET_FILTER:
      return {
        ...state,
        filter: action.partnerId
      }
    case TAB_STATE_CHANGE:
      return {
        ...state,
        tabState: action.tabState
      }
    case USER_GROUP_PATCH_DIALOG_RECEIVE:
      const updatedGroupsProfile = {
        ...state.userProfile,
        groups: [...state.userProfile.groups.concat(state.selected)]
      }
      return {
        ...state,
        userProfile: updatedGroupsProfile
      }
    case USER_PROFILE_RECEIVE:
      return {
        ...state,
        userProfile: action.data
      }
    case USER_PROFILE_FAILURE:
      return {
        ...state,
        userProfile: null
      }
    case USERS_RECEIVE:
      const cleanedUsers = cleanUsers(action.payload.data.items)
      return {
        ...state,
        totalCount: action.payload.data.totalCount,
        users: cleanedUsers.sort((a, b) => a.fullName > b.fullName)
      }
    case USER_POST_DIALOG_RECEIVE:
      const cleanedUser = cleanUser(action.payload.data.item)
      const updatedUsers = [...state.users]
      updatedUsers.unshift(cleanedUser)
      return {
        ...state,
        users: updatedUsers.sort((a, b) => a.fullName > b.fullName)
      }
    case SET_USER_PATCH:
      return {
        ...state,
        selected: action.patch
      }
    case SHOW_ADMINS_DIALOG:
      return {
        ...state,
        openAdminsDialog: action.changeAdminsDialogState,
      }
    case FILTER_ADMINS:
      const admins = filterAdmins(action.users)
      return {
          ...state,
          admins: admins
      }
    default:
      return state
  }
}


export const changeTabState = (tabState) => ({type: TAB_STATE_CHANGE, tabState})

export function cleanUsers(users) {
  return users.map((user)=>{
    return cleanUser(user)
  })
}

function cleanUser(user) {
  let fullName = (user.firstName && user.lastName) ?
    `${user.firstName || ''} ${user.lastName || ''}` : '<registration email sent>'
  let isAdmin = false
  let adminForPartners = []
  if(user.userInfo) {
    const userInfo = JSON.parse(user.userInfo)
    const groups = userInfo.groups
    if(typeof groups !== 'undefined') {
      groups.forEach(group => {
        if(containsRole(group.roles, 'admin')) {
          adminForPartners.push(group.partner)
          isAdmin = true
        }
      })
    }
  }

  return {
    ...user,
    fullName,
    isAdmin,
    adminForPartners
  }
}

export const setFilter = (partnerId) => ({type: SET_FILTER, partnerId})

export function fetchUserProfile(id) {
  return (dispatch) => {
    dispatch({type: USER_PROFILE_REQUEST})
    return Promise.all([
      dispatch(fetchSingleUser(id)),
      dispatch(fetchSingleUserGroups(id))
    ])
    .then(response => {
      let profile = {}
      response.forEach(userData => {
        const fetchName = userData.type.split('_')[1].toLowerCase()
        if (userData.error) {
          profile.error = true
          profile[fetchName] = []
        } else {
          profile[fetchName] = userData.payload.data.item ? userData.payload.data.item : userData.payload.data.items
        }
      })
      if (profile.error === true) {
        dispatch({type: USER_PROFILE_FAILURE})
        dispatch({type: INITIAL_DATA_FAILURE})
      } else {
        dispatch({
          type: USER_PROFILE_RECEIVE,
          data: profile
        })
      }
    })
  }
}

export function fetchSingleUserGroups(userId) {
  return {
    [CALL_API]: {
      endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/users/${userId}/groups` :
        `/api/v1/authz/users/${userId}/groups`,
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      types: [USER_GROUPS_REQUEST, USER_GROUPS_RECEIVE, USER_GROUPS_FAILURE]
    }
  }
}

export function fetchSingleUser(userId) {
  return {
    [CALL_API]: {
      endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/users/${userId}` :
        `/api/v1/authz/users/${userId}`,
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      types: [SINGLE_USER_REQUEST, SINGLE_USER_RECEIVE, SINGLE_USER_FAILURE]
    }
  }
}

export function fetchUsers(isRefreshRequired) {
  return (dispatch, getState) => {
    const queries = constructQueries(getState(), 'user')
    return dispatch({
      [CALL_API]: {
        endpoint: constructEndpoint('/api/v1/authz/users', queries.join(''), isLocal()),
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        types: [ USERS_REQUEST,
          {
            type: USERS_RECEIVE,
            meta: { isRefreshRequired : isRefreshRequired ? true : false }
          },
          {
            type: USERS_FAILURE,
            meta: { isRefreshRequired : isRefreshRequired ? true : false }
          }
        ]
      }
    })
  }
}

export function patchUserGroups(userId, selectedGroups) {
  return (dispatch, getState) => {
    let newGroups = []
    selectedGroups.forEach(selected => {
      getState().group.groups.forEach(group => {
        if (group.id === selected) {
          newGroups.push(group)
        }
      })
    })
    const { csrfToken } = getState().csrf
    dispatch({type: SET_USER_PATCH, patch: newGroups})
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/users/${userId}/groups` :
          `/api/v1/authz/users/${userId}/groups`,
        method: 'PUT',
        body: JSON.stringify({ids: selectedGroups}),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        types: [USER_GROUP_PATCH_DIALOG_REQUEST, USER_GROUP_PATCH_DIALOG_RECEIVE, USER_GROUP_PATCH_DIALOG_FAILURE]
      }
    })
  }
}

export function createUser(data, partnerId, partnerName) {
  let bodyData = {}
  bodyData.applicationIds = [data.applicationId]
  bodyData.email = data.email
  bodyData.groupIds = data.groupIds
  bodyData.firstName = data.firstName
  bodyData.lastName = data.lastName
  if (partnerId) {
    bodyData.partners = [{ id: partnerId, name: partnerName }]
  } else {
    bodyData.partners = [JSON.parse(data.partnerId)]
  }

  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/users` :
          `/api/v1/authz/users`,
        method: 'POST',
        body: JSON.stringify(bodyData),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        types: [USER_POST_DIALOG_REQUEST, USER_POST_DIALOG_RECEIVE, USER_POST_DIALOG_FAILURE]
      }
    })
  }
}

export function fetchPartner(partner, fetchGroupsBool) {
  const partnerReceive = { type: PARTNER_RECEIVE }
  if (fetchGroupsBool) {
    partnerReceive.meta = { fetchGroups: true }
  }

  return {
    [CALL_API]: {
      endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/partners/${partner.id}` :
        `/api/v1/authz/partners/${partner.id}`,
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      types: [PARTNER_REQUEST, partnerReceive, PARTNER_FAILURE]
    }
  }
}

export function resetPassword(userId) {
  return {
    [CALL_API]: {
      endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/users/${userId}/email/change_password` :
        `/api/v1/authz/users/${userId}/email/change_password`,
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      types: [RESET_PASSWORD_DIALOG_REQUEST, RESET_PASSWORD_DIALOG_RECEIVE, RESET_PASSWORD_DIALOG_FAILURE]
    }
  }
}

export function resendVerificationEmail(userId) {
  return {
    [CALL_API]: {
      endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/users/${userId}/email/register` :
        `/api/v1/authz/users/${userId}/email/register`,
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      types: [RESEND_VERIFICATION_EMAIL_DIALOG_REQUEST, RESEND_VERIFICATION_EMAIL_DIALOG_RECEIVE, RESEND_VERIFICATION_EMAIL_DIALOG_FAILURE]
    }
  }
}

export const manualSetUserProfile = (payload) => ({ type: MANUAL_SET_USER_PROFILE, payload })

function isLocal() {
  return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
}

export function deleteUserFromGroup(groupId, userIdToDelete) {
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/groups/${groupId}/users` :
          `/api/v1/authz/groups/${groupId}/users`,
        method: 'DELETE',
        body: JSON.stringify({ids:[userIdToDelete]}),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        types: [
          DELETE_USER_FROM_GROUP_DIALOG_REQUEST,
          {
            type: DELETE_USER_FROM_GROUP_DIALOG_RECEIVE,
            meta: { groupIdToFilter: groupId}
          },
          DELETE_USER_FROM_GROUP_DIALOG_FAILURE
        ]
      }
    })
  }
}

export function deleteUser(userId) {
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/users/${userId}` :
          `/api/v1/authz/users/${userId}`,
        method: 'DELETE',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        types: [
          DELETE_USER_DIALOG_REQUEST,
          {
            type: DELETE_USER_DIALOG_RECEIVE,
            meta: { userId }
          },
          DELETE_USER_DIALOG_FAILURE
        ]
      }
    })
  }
}
function filterAdmins(items) {
  let { users, userPartners } = items
  let admins = []
  users.forEach(user => {
    // search all users for admins
      if(user.isAdmin && user.adminForPartners.length > 0) {
        // If the user is an admin for some partner (adminForPartners = arr of partners they are admin for)
        let partners = userPartners.filter(partner => {
          // find admin for logged in user's partner list
          return user.adminForPartners.find(item => item.id === partner.id )
        })

        if (partners.length > 0) {
          admins.push({id: user.id, firstName: user.firstName, lastName: user.lastName, email: user.email, partners: partners})
        }
      }
  })
  return admins
}
export const showAdminsDialog = (changeAdminsDialogState) => ({ type: SHOW_ADMINS_DIALOG, changeAdminsDialogState } )

export const filterAdminsForUser = (users) => ({type: FILTER_ADMINS, users})

export default reducer
